module.exports = __webpack_public_path__ + "static/prodinity_horizontal_logo-bf751308fd71d74b9e6047006800b6e9.svg";